module.exports = __webpack_public_path__ + "assets/img/illust_01_large.643c5a59.png";